import {
  Alert,
  Typography,
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  CircularProgress,
  Container,
  Link,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { Window as WindowIcon } from "@mui/icons-material";

import { loginWithEmail, microsoftLogin } from "../../actions/auth.js";
import { useEffect } from "react";

import { makeStyles } from "@mui/styles";
import { Axios } from "axios";
import Captcha from "../../components/captcha.jsx";
import useErrorHandler from "../../hooks/useErrorHandler.js";
import VastEdgeLogo from "../../images/vastedge-logo-white-small.png";
import useSnackbar from "../../hooks/useSnackbar.js";
const useStyles = makeStyles((theme) => ({
  odrBox: {
    "&&": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      transform: "translate(-50%, -50%)",
      top: "50%",
      left: "50%",

      "@media (max-width: 520px)": {
        marginBottom: "20px",
        width: "90%",
      },
    },
  },
  odrPaperWidth: {
    maxWidth: "445px",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px !important",
    backgroundColor: "#fff !important",
    color: "rgba(0, 0, 0, 0.87) !important",
    WebkitTransition:
      "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms !important",
    borderRadius: "4px !important",
  },
  odrLoginPage: {
    background:
      "radial-gradient(50% 50% at 50% 50%, #005480  0%, #0c7eb6 100%)",
    height: "100%",
    position: "absolute",
    left: "0",
    width: "100%",
    maxWidth: "100% !important",
    "@media (max-width: 520px)": {
      position: "relative",
    },
  },
  odrLoginHeader: {
    margin: "14px 0px 0px 14px !important",
  },
  odrBoxTitle: {
    "&&": {
      display: "flex",
      flexDirection: "row",
      webkitBoxAlign: "center",
      alignItems: "center",
      WebkitBoxPack: "justify",
      justifyContent: "space-between",
    },
  },
}));

export default function Login() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleError = useErrorHandler();
  const { isLoggedIn, err } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef();
  const [errorMsg, setErrorMsg] = useState("");
  const snackbar = useSnackbar();

  useEffect(() => {
    setLoading(false);
  }, [isLoggedIn, err]);

  const [data, setData] = useState({ email: "", password: "" });
  const handleInputChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    const newdata = await captchaRef.current.checkAnswer();
    if (newdata[0] === true) {
      setLoading(true);

      dispatch(loginWithEmail(data)).then((res) => {
        setLoading(false);
        captchaRef.current.numRefresh();
        snackbar.showError(res.error);
      });
    } else if (newdata[1] === "") {
      setErrorMsg("Enter the captcha.");
    } else {
      setErrorMsg("Captcha Mismatch");
    }
  };
  const handleMicrosoftLogin = () => {
    dispatch(microsoftLogin());
  };
  const handleAnotherComponentClick = () => {
    // Trigger the checkAnswer function in the Captcha component
    // by calling it through the ref
    captchaRef.current.checkAnswer();
  };

  return isLoggedIn ? (
    <Navigate to="/dashboard" replace="true" />
  ) : (
    <Container maxWidth="xl" className={classes.odrLoginPage}>
      <Box
        style={{
          minHeight: "100vh",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12} className={classes.odrLoginHeader}>
            <Link href="https://www.vastedge.com/">
              <img src={VastEdgeLogo} height="45" />
            </Link>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Box className={classes.odrBox}>
              <Paper elevation={3} className={classes.odrPaperWidth}>
                <Box
                  component="form"
                  onSubmit={handleLoginSubmit}
                  maxWidth={800}
                  px={2}
                  pb={2}
                  pt={2}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Box className={classes.odrBoxTitle}>
                        <Typography variant="h5" fontWeight={700}>
                          Login
                        </Typography>
                        {loading ? <CircularProgress /> : <></>}

                        {Boolean(err) ? (
                          <Alert severity="error">{err}</Alert>
                        ) : (
                          <></>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        value={data.email}
                        type="email"
                        label="Email"
                        onChange={handleInputChange}
                        name="email"
                        autoComplete="username"
                        required
                        fullWidth
                        size="small"
                        className="inputRounded"
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        value={data.password}
                        type="password"
                        label="Password"
                        onChange={handleInputChange}
                        name="password"
                        required
                        autoComplete="current-password"
                        fullWidth
                        size="small"
                        className="inputRounded"
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <Box
                      // display="flex" justifyContent="center"
                      >
                        <Captcha errorMsg={errorMsg} ref={captchaRef} />
                        {/* <p st>{errorMsg}</p> */}
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} mt={1}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            fullWidth
                            size="large"
                            className="blue-button"
                          >
                            Submit
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                          <Button
                            variant="text"
                            // color="secondary"
                            fullWidth
                            onClick={() => {
                              navigate("/forget-password", { replace: true });
                            }}
                          >
                            Reset Password
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* <Grid item xs={12} md={12} lg={12} textAlign='center' >

              <Button variant='outlined' fullWidth onClick={handleMicrosoftLogin}>
                <WindowIcon sx={{mr: 2}} /> Log In With Microsoft
              </Button>
            </Grid> */}
                  </Grid>
                </Box>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
